document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-container').forEach((container) => {
    const playButton = container.querySelector('.mx-button');
    const video = container.querySelector('video');

    if (!playButton || !video) return;

    playButton.addEventListener('click', function () {
      video.muted = false;
      video.play();
      video.setAttribute('controls', 'true');
      playButton.style.display = 'none';

      // Pause toutes les autres vidéos
      document.querySelectorAll('.video-container video').forEach((v) => {
        if (v !== video) {
          v.pause();
          v.removeAttribute('controls');
          v.muted = true;
          const btn = v.closest('.video-container').querySelector('.mx-button');
          if (btn) btn.style.display = 'block';
        }
      });
    });

    video.addEventListener('click', function () {
      if (video.paused) {
        video.muted = false;
        video.play();
        video.setAttribute('controls', 'true');
        playButton.style.display = 'none';
      } else {
        video.pause();
        video.removeAttribute('controls');
        video.muted = true;
        playButton.style.display = 'block';
      }
    });
  });
});
